import { DatePicker, Button, Tooltip } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import "./DateFilter.scss";
import { ReactComponent as Calendar } from "../../assets/Icons/calendarIcon.svg";

const { RangePicker } = DatePicker;

const DateFilter = ({ onDateChange, isTruncate = true, showDate = true }) => {
  const [range, setRange] = useState([]);
  const [open, setOpen] = useState(false);

  const handleChange = (dates) => {
    setRange(dates || []);

    if (dates?.length === 2 && dates[0] && dates[1]) {
      const [from, to] = dates;
      setOpen(false);
      onDateChange?.(from, to);
    }

    // When cleared
    if (!dates || dates.length === 0) {
      onDateChange?.(null, null);
    }
  };

  const clearRange = (e) => {
    e.stopPropagation();
    setRange([]);
    onDateChange?.(null, null);
  };

  useEffect(() => {
 if(!showDate){
    setRange([]);
    onDateChange?.(null, null);
 }
  }, [showDate])

  const fullLabel =
    range.length === 2
      ? `${dayjs(range[0]).format("DD MMM YYYY")} - ${dayjs(
        range[1]
      ).format("DD MMM YYYY")}`
      : (isTruncate ? 'Date Filter' : 'Select Date Range');

  const MAX_LENGTH = isTruncate ? 15 : 200;

  const displayLabel =
    fullLabel.length > MAX_LENGTH
      ? fullLabel.slice(0, MAX_LENGTH) + "..."
      : fullLabel;


  return (
    <div className="date-filter-component">
      <Button
        icon={<Calendar />}
        onClick={() => setOpen(true)}
        className="date-filter-button"
      >
        <Tooltip
          title={range.length === 2 ? fullLabel : ""}
          placement="bottom"
        >
          <span className="date-label" style={{ fontSize: '12px' }}>{displayLabel}</span>
        </Tooltip>

        {range.length === 2 && (
          <CloseOutlined
            className="clear-icon"
            onClick={clearRange}
          />
        )}
      </Button>


      <RangePicker
        open={open}
        onOpenChange={setOpen}
        value={range}
        onChange={handleChange}
        allowClear
        className="hidden-picker"
        getPopupContainer={() => document.body}
        style={{
          position: "absolute",
          opacity: 0,
          pointerEvents: "none",
          width: 0,
          height: 0,
        }}
      />
    </div>
  );
};

export default DateFilter;
